//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Qhelp from "../../mixins/Qhelp";
import PageFooter from "../../components/footer/PageFooter";
export default {
  name: 'TfaResetProcess',
  mixins: [Qhelp],
  data: function data() {
    return {
      code: null,
      success: false,
      error: false
    };
  },
  components: {
    PageFooter: PageFooter
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;
    this.code = this.$route.params.code;
    this.$axios.put("/auth/tfa/reset/process", {
      code: this.code
    }).then(function (response) {
      _this.success = true;
    }).catch(function () {
      _this.error = true;
    });
    this.$gtag.pageview({
      page_path: this.$route.path
    });
  }
};